<template>
    <v-app>
        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style lang="scss" scoped>
.theme--light.v-application {
    background: #ffffff;
}
</style>
